import { ArchiveIcon, PinIcon, PinOffIcon, Trash2Icon } from 'lucide-react'
import type { ReactNode } from 'react'

import { DropdownMenuGroup, DropdownMenuItem } from '@/components/ui/dropdown-menu'

import type { ChatItemActions } from './sidebar-item-actions.interface'

interface SidebarChatActionsSecondaryProps {
  chatId: string
  isPinned: boolean
  actions: ChatItemActions
}

export const SidebarChatActionsSecondary = ({
  chatId,
  isPinned,
  actions,
}: SidebarChatActionsSecondaryProps): ReactNode => (
  <DropdownMenuGroup>
    <DropdownMenuItem onClick={() => actions.onPin(chatId)}>
      {isPinned ? (
        <>
          <PinOffIcon />
          Unpin chat
        </>
      ) : (
        <>
          <PinIcon />
          Pin chat
        </>
      )}
    </DropdownMenuItem>
    <DropdownMenuItem onClick={() => actions.onArchive(chatId)}>
      <ArchiveIcon />
      Archive
    </DropdownMenuItem>
    <DropdownMenuItem variant="destructive" onClick={() => actions.onDelete(chatId)}>
      <Trash2Icon />
      Delete
    </DropdownMenuItem>
  </DropdownMenuGroup>
)
